exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "@charset \"UTF-8\";\n.style_breadcrumbs__1Yw6Z {\n  padding: 0.76rem 1.53rem;\n  background-color: #fff;\n  border-bottom: 1px solid #e4e9f0; }\n\n.style_path__3UEuy {\n  font-size: 1.38rem;\n  color: #0e0b20; }\n\n.style_arrow__1NmmK {\n  display: inline-block;\n  margin: 0 0.76rem; }\n  .style_arrow__1NmmK:after {\n    display: inline-block;\n    content: '·'; }\n", ""]);

// Exports
exports.locals = {
	"breadcrumbs": "style_breadcrumbs__1Yw6Z",
	"path": "style_path__3UEuy",
	"arrow": "style_arrow__1NmmK"
};